import React from 'react';

class Footer extends React.Component {

  componentWillMount() {
  }

  render() {
  	return (
      <div>
        <footer className="cpoy-right-bg">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="social-footer">
                  <ul>
                    <li><a href="mailto:me@johnbernazzani.com" target="_top" rel="noopener noreferrer"  dangerouslySetInnerHTML={{ __html: '<i class="fa fa-envelope" aria-hidden="true"></i>' }}></a></li>
                    <li><a href="https://linkedin.com/in/johnbernazzani" target="_blank" rel="noopener noreferrer" dangerouslySetInnerHTML={{ __html: '<i class="fa fa-linkedin" aria-hidden="true"></i>' }}></a></li>
                    <li><a href="https://github.com/johnbernazzani" target="_blank" rel="noopener noreferrer" dangerouslySetInnerHTML={{ __html: '<i class="fa fa-github" aria-hidden="true"></i>' }}></a></li>
                    <li><a href="https://dribbble.com/johnbernazzani" target="_blank" rel="noopener noreferrer" dangerouslySetInnerHTML={{ __html: '<i class="fa fa-dribbble" aria-hidden="true"></i>' }}></a></li>
                    <li><a href="https://twitter.com/jbernazz" target="_blank" rel="noopener noreferrer"  dangerouslySetInnerHTML={{ __html: '<i class="fa fa-twitter" aria-hidden="true"></i>' }}></a></li>
                    <li><a href="https://instagram.com/jbernazz" target="_blank" rel="noopener noreferrer"  dangerouslySetInnerHTML={{ __html: '<i class="fa fa-instagram" aria-hidden="true"></i>' }}></a></li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12 text-center">
                <p className="copyright">© 2019 John Bernazzani | Made with <i class="fa fa-heart"></i> and <a href="https://reactjs.org/" target="_blank" rel="noopener noreferrer">React</a></p>
              </div>
            </div>
          </div>
        </footer>
      </div>
  	);
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js